import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage} from 'firebase/storage'
// import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQnE_-517eEwUu_AoOZG18aWXWLe39N-g",
  authDomain: "ccuc-5c7d5.firebaseapp.com",
  projectId: "ccuc-5c7d5",
  storageBucket: "ccuc-5c7d5.appspot.com",
  messagingSenderId: "153751273421",
  appId: "1:153751273421:web:560e96b2febe9000c2ce84",
  measurementId: "G-7V0P1YYGMN"
};

console.log('firebase')
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const projectStorage = getStorage(app);
export { projectStorage}
